import { render, staticRenderFns } from "./LicencesListItem.vue?vue&type=template&id=7e4dc720&"
import script from "./LicencesListItem.vue?vue&type=script&lang=js&"
export * from "./LicencesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports